<template>
  <component :is="layoutComponent" :body-class="bodyClass" :active-sidebar="activeSidebar">
    <router-view />
  </component>
</template>

<script>
import { Tooltip } from 'bootstrap'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import DeluxeLayout from '@/layouts/DeluxeLayout.vue'
import BlankLayout from '@/layouts/BlankLayout.vue'
import 'dotenv/config'

export default {
  name: 'App',
  components: {
    DefaultLayout,
    DeluxeLayout,
    BlankLayout
  },
  computed: {
    layoutComponent() {
      if (this.$route.meta.layout === 'blank') {
        return 'BlankLayout'
      }

      return this.$route.meta.layout === 'deluxe' ? 'DeluxeLayout' : 'DefaultLayout'
    },
    bodyClass() {
      return this.$route.meta.bodyClass || ''
    },
    activeSidebar() {
      return this.$route.meta.activeSidebar || ''
    }
  },
  mounted() {
    new Tooltip(document.body, {
      selector: "[data-bs-toggle='tooltip']",
    })
  }
}
</script>
